export default "__VITE_ASSET__505ff21d__"